import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'

// 创建axios实例
const service = new axios.create({

})

// 添加请求拦截器
service.interceptors.request.use(config => {
  console.log('发起请求', config)
  if (config.method == 'post') {
    config.data.reg_time = new Date().getTime();
    config.data = qs.stringify(config.data) // 将对象 序列化成URL的形式，以&进行拼接
  }
  return config
}, error => {
  return new Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(config => {
  console.log('请求结果：', config)
  return config
}, error => {
  return new Promise.reject(error)
})

// 将service挂载到Vue原型上
Vue.prototype.$http = service

export default service



// WEBPACK FOOTER //
// ./src/api/request.js